<div class="main">
  <tbtk-appbar *ngIf="!isPubliclySharedPage"></tbtk-appbar>
  <tbtk-sidenav
    *ngIf="
      !isPubliclySharedPage && !(pathService.getCurrentPath().includes('posta') || pathService.getCurrentPath().includes('not') || pathService.getCurrentPath().includes('kimlik'))
    "
    [header]="sidenav.header"
    [items]="sidenav.items"
    [quota]="sidenav.quota"
  ></tbtk-sidenav>
  <div class="main-content">
    <tbtk-header *ngIf="!isPubliclySharedPage" [value]="searchValue" [modalId]="'folderTreeModal'" (onEnter)="onSearch($event)">
      <div detailSearch class="detail-search" *ngIf="!isPubliclySharedPage">
        <tbtk-detail-search></tbtk-detail-search>
      </div>
      <ng-container right>
        <app-top-right-dropdown
          [profileSettingLink]="'/profil-ayarlari'"
          [secureSettingLink]="'/sifreli-depo-guncelleme'"
          [securitySettingsLink]="'/guvenlik-ayarlari'"
          [helpLink]="'/yardim-merkezi'"
          (exitClick)="logout()"
          (docxClick)="commonService.chosenDocument.next('docx')"
          (pptClick)="commonService.chosenDocument.next('ppt')"
          (xlsxClick)="commonService.chosenDocument.next('xlsx')"
          (templateDocumentClick)="commonService.isDocumentTemplateSelected.next(true)"
          (createFolder)="createFolder($event, false)"
        >
        </app-top-right-dropdown>
      </ng-container>
    </tbtk-header>
    <div class="main-content-area" id="main-content-area">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<tbtk-file-upload-animation *ngIf="!isFileUploadClosed" [downloadItems]="downloadService.downloadChunks" [uploadItems]="uploadChunks" (closeFileUpload)="closeModal()">
</tbtk-file-upload-animation>
<app-folder-tree-modal
  #folderTreeComp
  *ngIf="commonService.folderTreeModalOpened$ | async"
  [selectedItems]="selectedItems"
  [selectedFolderId]="selectedItem?.objectId"
  [selectedFolderorFile]="selectedItem"
  (newFolderClicked)="createFolder($event, true)"
>
</app-folder-tree-modal>
<app-create-encrypted-folder-modal
  *ngIf="openedModalId === '#createEncryptedFolderModal' || (modalService.isEncryptedCreateFolderModalVisible$ | async)"
  [fromFolderTree]="fromFolderTree"
  (newFolderCreated)="newFolderCreated($event, false)"
>
</app-create-encrypted-folder-modal>
<app-create-folder-modal
  *ngIf="openedModalId === '#createFolderModal' || (modalService.isCreateFolderModalVisible$ | async)"
  [fromFolderTree]="fromFolderTree"
  (newFolderCreated)="newFolderCreated($event, true)"
>
</app-create-folder-modal>
<app-share-modal *ngIf="openedModalId === '#firstShare'" [selectedItem]="selectedItem"></app-share-modal>
<app-multi-share-modal *ngIf="openedModalId === '#multiShare'"></app-multi-share-modal>
<app-multi-create-link *ngIf="openedModalId === '#multiCreateLink'"></app-multi-create-link>
<app-create-link-modal *ngIf="openedModalId === '#createLink'"></app-create-link-modal>
<app-manage-links-modal></app-manage-links-modal>
<app-manage-link-modal></app-manage-link-modal>
<app-share-management-modal *ngIf="openedModalId === '#shareManagementModal'"></app-share-management-modal>
<app-share-details-modal *ngIf="openedModalId === '#shareDetailsModal'" [privateShareId]="selectedItem?.privateShareId"></app-share-details-modal>
<div #dragItem id="drag-item"> </div>
<app-document-template></app-document-template>
